import {
	Box,
	ImageWrapper,
	Heart,
	ImageOverlay,
	TopTitle,
	Checkmark,
} from './Category.styles';
import FilledHeart from '../../images/filled-heart.svg';
import BlankHeart from '../../images/blank-heart.svg';
import CheckmarkIcon from '../../images/checkmark-white.svg';
import { Scene } from '../../types/Scene';

type Props = {
	onAddToFavorite: () => void;
	isFavorite: boolean;
	onClick: () => void;
	data: Scene;
};

function Category({
	onAddToFavorite: handleAddToFavorite,
	isFavorite,
	onClick,
	data: d,
}: Props) {
	return (
		<Box onClick={onClick}>
			<ImageWrapper>
				<TopTitle>
					<div>{d.name}</div>
				</TopTitle>
				<img src={d?.image} alt={d.name} />
				<ImageOverlay />
				<Heart
					onClick={(e) => {
						e?.preventDefault();
						e?.stopPropagation();
						handleAddToFavorite();
					}}
				>
					<img src={isFavorite ? FilledHeart : BlankHeart} />
				</Heart>
				{d.completed && (
					<Checkmark>
						<img src={CheckmarkIcon}></img>
					</Checkmark>
				)}
			</ImageWrapper>
		</Box>
	);
}

export default Category;
